import * as React from 'react'
import { useState, cloneElement, useContext } from "react";
import { chevronIcon, contentIcon } from "./Icons.js"
import { useAppState } from '../content-builder-components/ContentBuilderStateProvider.js'
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json.js';
import { PolymerMenu , PolymerMenuDivider, PolymerMenuOption} from '../uikit-components/Menu.js';

const SidebarContext = React.createContext()

function useSideBarState() {
    const context = React.useContext(SidebarContext)
    if (!context) {
        throw new Error(`useAppState must be used within a AppStateProvider`)
    }
    return context
}

function Sidebar({ selectedId, setSelectedId, children, isTop , onDelete, onRename, toolbarBottom, toolbarTop }) {

    let contextValue = {
        selectedId: selectedId,
        setSelectedId: setSelectedId,
        onDelete: onDelete,
        onRename: onRename
    }

    var className = isTop ? "top" : ""

    const top    = toolbarTop ? <div className="sidebar-toolbar-safearea top">{toolbarTop}</div> : null
    const bottom = toolbarBottom ? <div className="sidebar-toolbar-safearea bottom">{toolbarBottom}</div> : null

    return (
        <section className="sidebar">
            <div className={`sidebar-content sidebar-tree ${className}`}>
                <SidebarContext.Provider value={contextValue}>
                    {top}
                    {children}
                    {bottom}
                </SidebarContext.Provider>
            </div>
        </section>
    );
}

const SidebarSectionContext = React.createContext()

function SidebarToolbar({ children }) {
    return <div className="sidebar-toolbar">{children}</div>
}

function SidebarContent(props) {
    const context = React.useContext(SidebarSectionContext)
    const { isExpanded, setIsExpanded } = context

    let content = isExpanded ? props.children : ""
    return <div className="sidebar-section-content">{content}</div>
}

function SidebarSection(props) {
    const [isExpanded, setIsExpanded] = useState(props.expanded != null ? props.expanded : true)

    let level = props.level ?? 0
    let paddingLeft = 0
    if (level > 0) {
        paddingLeft = ((12 * level) + 10)
    }

    let contextValue = {
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        paddingLeft: paddingLeft 
    }

    return (
        <div className="sidebar-section noselect"  style={{}} >
            <SidebarSectionContext.Provider value={contextValue}>
                {props.children}
            </SidebarSectionContext.Provider>
        </div>
    )
}

function SidebarNavBack(props) {
    var chevronBack = <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.761719 6.41699C0.761719 6.67725 0.856934 6.89307 1.06641 7.09619L5.9541 11.876C6.11279 12.041 6.31592 12.1235 6.55078 12.1235C7.02686 12.1235 7.40771 11.7427 7.40771 11.2666C7.40771 11.0254 7.3125 10.8159 7.14111 10.6445L2.79932 6.41064L7.14111 2.18945C7.3125 2.01807 7.40771 1.80225 7.40771 1.56738C7.40771 1.09131 7.02686 0.716797 6.55078 0.716797C6.30957 0.716797 6.11279 0.792969 5.9541 0.958008L1.06641 5.73779C0.856934 5.94092 0.768066 6.15674 0.761719 6.41699Z" fill="#0085FF" />
    </svg>

    return <div className="nav-back" onClick={props.onClick}>{chevronBack}{props.title}</div>
}
function SidebarSeparator() {
    return <div className="sidebar-separator"></div>
}

function SidebarTitleHeader({ title, subtitle, description }) {
    return <div className="title-header-container"><div className="subtitle">{subtitle}</div><h1>{title}</h1><div className="desc">{description}</div></div>
}

const chevronDown = <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.86133 7.13867C6.1543 7.13867 6.40039 7.02734 6.62891 6.79297L10.9648 2.35742C11.1406 2.18164 11.2285 1.9707 11.2285 1.71289C11.2285 1.19141 10.8125 0.769531 10.2969 0.769531C10.0449 0.769531 9.80469 0.875 9.61133 1.06836L5.86719 4.93555L2.11719 1.06836C1.92383 0.875 1.68359 0.769531 1.42578 0.769531C0.910156 0.769531 0.494141 1.19141 0.494141 1.71289C0.494141 1.96484 0.582031 2.17578 0.757812 2.35742L5.09375 6.79297C5.33398 7.0332 5.57422 7.13867 5.86133 7.13867Z" fill="black" fillOpacity="0.15" />
</svg>

const chevronUp = <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.86133 0.861328C6.1543 0.861328 6.40039 0.972656 6.62891 1.20703L10.9648 5.64258C11.1406 5.81836 11.2285 6.0293 11.2285 6.28711C11.2285 6.80859 10.8125 7.23047 10.2969 7.23047C10.0449 7.23047 9.80469 7.125 9.61133 6.93164L5.86719 3.06445L2.11719 6.93164C1.92383 7.125 1.68359 7.23047 1.42578 7.23047C0.910156 7.23047 0.494141 6.80859 0.494141 6.28711C0.494141 6.03516 0.582031 5.82422 0.757812 5.64258L5.09375 1.20703C5.33398 0.966797 5.57422 0.861328 5.86133 0.861328Z" fill="black" fillOpacity="0.15" />
</svg>

const checkmarkIcon = <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.2" d="M5.18896 12.1743C5.62061 12.1743 5.95703 12.0093 6.18555 11.6602L12.1016 2.61475C12.2666 2.36084 12.3364 2.12598 12.3364 1.90381C12.3364 1.30713 11.8921 0.875488 11.2827 0.875488C10.8638 0.875488 10.6035 1.02783 10.3496 1.42773L5.15723 9.61621L2.52295 6.34717C2.28809 6.06787 2.03418 5.94092 1.67871 5.94092C1.06299 5.94092 0.618652 6.37891 0.618652 6.97559C0.618652 7.24219 0.701172 7.47705 0.929688 7.7373L4.20508 11.7046C4.47803 12.0283 4.78271 12.1743 5.18896 12.1743Z" fill="black" />
</svg>

const deleteIcon = <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path  style={{"fill": "var(--content-builder-ui-tint-color)"}} d="M5.375 15.9922C5.52604 15.9922 5.64844 15.9479 5.74219 15.8594C5.83594 15.7708 5.88021 15.6562 5.875 15.5156L5.625 6.90625C5.625 6.76042 5.57812 6.64583 5.48438 6.5625C5.39062 6.47917 5.27083 6.4375 5.125 6.4375C4.96875 6.4375 4.84375 6.48177 4.75 6.57031C4.66146 6.65365 4.61979 6.76823 4.625 6.91406L4.85938 15.5156C4.86979 15.6615 4.91927 15.7786 5.00781 15.8672C5.10156 15.9505 5.22396 15.9922 5.375 15.9922ZM7.75781 15.9922C7.91406 15.9922 8.03906 15.9505 8.13281 15.8672C8.23177 15.7786 8.28125 15.6615 8.28125 15.5156V6.91406C8.28125 6.76823 8.23177 6.65365 8.13281 6.57031C8.03906 6.48177 7.91406 6.4375 7.75781 6.4375C7.60677 6.4375 7.48177 6.48177 7.38281 6.57031C7.28906 6.65365 7.24219 6.76823 7.24219 6.91406V15.5156C7.24219 15.6615 7.28906 15.7786 7.38281 15.8672C7.48177 15.9505 7.60677 15.9922 7.75781 15.9922ZM10.1484 15.9922C10.2995 15.9922 10.4193 15.9505 10.5078 15.8672C10.6016 15.7839 10.651 15.6667 10.6562 15.5156L10.8906 6.91406C10.8958 6.76823 10.8516 6.65365 10.7578 6.57031C10.6693 6.48177 10.5469 6.4375 10.3906 6.4375C10.25 6.4375 10.1328 6.47917 10.0391 6.5625C9.94531 6.64583 9.89583 6.76302 9.89062 6.91406L9.64844 15.5156C9.64323 15.6615 9.6849 15.7786 9.77344 15.8672C9.86719 15.9505 9.99219 15.9922 10.1484 15.9922ZM4.32812 4.53906V2.78906C4.32812 2.22656 4.5 1.78385 4.84375 1.46094C5.19271 1.13281 5.66667 0.96875 6.26562 0.96875H9.23438C9.83333 0.96875 10.3047 1.13281 10.6484 1.46094C10.9974 1.78385 11.1719 2.22656 11.1719 2.78906V4.53906H9.92969V2.86719C9.92969 2.64844 9.85677 2.47135 9.71094 2.33594C9.57031 2.20052 9.38281 2.13281 9.14844 2.13281H6.35156C6.11719 2.13281 5.92708 2.20052 5.78125 2.33594C5.64062 2.47135 5.57031 2.64844 5.57031 2.86719V4.53906H4.32812ZM0.78125 5.16406C0.625 5.16406 0.486979 5.10677 0.367188 4.99219C0.252604 4.8724 0.195312 4.73177 0.195312 4.57031C0.195312 4.41406 0.252604 4.27865 0.367188 4.16406C0.486979 4.04427 0.625 3.98438 0.78125 3.98438H14.7422C14.8984 3.98438 15.0339 4.04167 15.1484 4.15625C15.263 4.27083 15.3203 4.40885 15.3203 4.57031C15.3203 4.73177 15.263 4.8724 15.1484 4.99219C15.0391 5.10677 14.9036 5.16406 14.7422 5.16406H0.78125ZM4.17969 18.3672C3.61719 18.3672 3.16146 18.2005 2.8125 17.8672C2.46875 17.5391 2.28385 17.0938 2.25781 16.5312L1.70312 5H13.8125L13.2656 16.5234C13.2396 17.0859 13.0521 17.5339 12.7031 17.8672C12.3542 18.2005 11.901 18.3672 11.3438 18.3672H4.17969Z"/>
</svg>

const renameIcon = <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path  style={{"fill": "var(--content-builder-ui-tint-color)"}} d="M3.34131 13.1162L1.33252 13.8882C1.21077 13.9325 1.1001 13.9048 1.00049 13.8052C0.906413 13.7056 0.88151 13.5921 0.925781 13.4648L1.73926 11.5142L11.0776 2.18408L12.6714 3.78613L3.34131 13.1162ZM13.4683 3.00586L11.8579 1.40381L12.7544 0.515625C12.9757 0.299805 13.2054 0.183594 13.4434 0.166992C13.6813 0.150391 13.9027 0.241699 14.1074 0.440918L14.4312 0.772949C14.6359 0.977702 14.7327 1.19629 14.7217 1.42871C14.7106 1.66113 14.5916 1.89079 14.3647 2.11768L13.4683 3.00586Z" />
</svg>


function SidebarSectionHeader({ title, action, canCollapse, sectionCount }) {
    const { isExpanded, setIsExpanded, paddingLeft } = React.useContext(SidebarSectionContext)

    const toggleExpand = () => {
        setIsExpanded(!isExpanded)
    }

    if (action || canCollapse) {
        const countElement = !isExpanded ? <div className="count noselect">{sectionCount}</div> : ""
        const collapseElement = canCollapse ? <div className="action">{isExpanded ? chevronDown : chevronUp}</div> : null
        const actionElement = action ? <div className="action">{action}</div> : null

        return <div className="header-container no-select" onClick={toggleExpand}  style={{ "paddingLeft" : ( (paddingLeft + 0) + "px") }}><h2 className="noselect">{title}</h2><div className="header-container-actions"  style={{  "marginRight" : (paddingLeft + "px") }}>{countElement}{actionElement}{collapseElement}</div></div>
    } else {
        return <div><h2>{title}</h2></div>
    }
}


function SidebarCategoryItem(props) {

    var { isExpanded, setIsExpanded } = useContext(SidebarSectionContext)

    if (props.onClick != null) {
        isExpanded = false
    }
    var onClick = () => {
        if (!props.onClick) {
            setIsExpanded(!isExpanded)
        } else {
            props.onClick()
        }
    }

    var className = isExpanded ? 'expanded' : ''

    var content = <div className="noselect">{props.title}</div>
    if (props.description) {
        content = <div>
            <div className="noselect title">{props.title}</div>
            <div className="noselect description">{props.description}</div>
        </div>
    }

    return <div className={`template-category-item noselect ${className}`} onClick={onClick}>
        <div className="content">
            {props.icon ? <div className="icon">{props.icon}</div> : null}
            {props.thumbnail ? <div className="thumbnail"><img src={props.thumbnail} /></div> : null}
            {content}
        </div>
    </div>
}


function SidebarTile(props) {
    let { selectedId, setSelectedId } = useSideBarState()

    const selectRow = function () {
        setSelectedId(props.id)
    }

    /** State */
    const isSelected = (selectedId == props.id)
    const selectedClass = isSelected ? "selected" : ""

    var style = {}
    if (props.thumbnail) {
        style['backgroundImage'] = 'url(' + props.thumbnail + ')'
    }

    return (<div className={`sidebar-tile ${selectedClass}`} onClick={selectRow}>
        <div className={"sidebar-tile-content"}>   <div className={"sidebar-tile-page"} style={style}></div> </div>
        <div className={"sidebar-tile-title"} contentEditable>{props.title}</div>
    </div>)
}

function SidebarAction(props) {
    const level = props.level ?? 0

    const iconElement = props.icon ? <span className="icon" >{contentIcon(props.icon, 'tint')}</span> : <span>&nbsp;</span>

    /** Class Generation */
    const contentClass = "sidebar-item-content"

    const checkmark = <span className="disclosure"></span>

    return (
        <div className={"sidebar-item sidebar-item-action noselect"}>
            <div className={contentClass} style={{ "paddingLeft": (20 * level) + "px" }} onClick={props.onClick}>
                {checkmark}
                {iconElement}
                <span>{props.title}</span>
            </div>
        </div>
    )
}

function SidebarToolbarAction(props) {

    const iconElement = props.icon ? <span className="icon" >{contentIcon(props.icon, 'tint')}</span> : <span>&nbsp;</span>

    const level = 0
    /** Class Generation */
    const contentClass = "sidebar-toolbar-action-content"

    return (
        <div className={"sidebar-toolbar-action noselect"}>
            <div className={contentClass} style={{ "paddingLeft": (20 * level) + "px" }} onClick={props.onClick}>
                {iconElement}
                <span>{props.title}</span>
            </div>
        </div>
    )
}

function SidebarItem(props) {
    let { selectedId, setSelectedId, onDelete, onRename } = useSideBarState()
    const sidebarSectionContext = React.useContext(SidebarSectionContext)
    var paddingLeft = 0
    if (sidebarSectionContext) {
        paddingLeft = sidebarSectionContext.paddingLeft
    }

    const [expanded, setExpanded] = useState(props.defaultExpanded ?? false)

    /** Events */
    const toggleExpand = function (e) {
        setExpanded(!expanded)
        if (e) {
            e.stopPropagation()
        }
        return false
    }

    const selectRow = function (e) {
        if (props.canSelect == false) { 
            toggleExpand(e)    
            return
        }
        setSelectedId(props.id)
    }

    const actionRename = function() {
        let name = prompt("Enter new name", props.fullTitle ?? props.title)
        if (name && name.length > 0) {  
            onRename(props.id, name)
        }
    }

    /** State */
    const isSelected = (selectedId == props.id)
    const level = props.level ?? 0
    const icon = props.icon
    const hasChildren = props.children ? true : false
    const canExpand = true//props.canExpand == null ? true : props.canExpand

    /** Chevron */
    const cicon = expanded ? "down" : "right"
    const tint = isSelected ? "#ffffff55" : "#00000033"
    const chevron = (canExpand ? (hasChildren ? <span className="disclosure" onClick={toggleExpand}>{chevronIcon(cicon, tint)}</span> : <span className="disclosure"></span>) : null)
    const iconElement = props.icon ? <span className="icon" >{contentIcon(icon, isSelected ? "#ffffff" : "#00000055")}</span> : <span>&nbsp;</span>
    const checkmark = <span className="disclosure">{checkmarkIcon}</span>

    if (chevron) {
        paddingLeft -= 10
    }
  
    /** Render children, passing level */
    const children = React.Children.map(props.children ?? [], child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { level: level + 1 })
        }
        return child
    });

    const childContent = expanded ? <div className="sidebar-item-children">
        {children}
    </div> : <div></div>

    /** Class Generation */
    var contentClass = "sidebar-item-content" + ((isSelected) ? " selected" : "")

    const iconContainerStyle = {
        display: "flex",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
        height: '20px'
    }

   
    let menuActions = [
        props.canDelete ? <PolymerMenuOption onClick={() => { onDelete(props.id) }} title="Delete" icon={deleteIcon}></PolymerMenuOption> : null,
        props.canRename ? <PolymerMenuOption onClick={actionRename} title="Rename" icon={renameIcon}></PolymerMenuOption> : null,
    ].filter( a => a != null)   

    let otherActions = (props.menuActions) ? props.menuActions(props.id) : []
    if (otherActions && otherActions.length > 0) {
        var compositeActions = [...otherActions]
        if (menuActions.length > 0) {
            compositeActions.push(<PolymerMenuDivider></PolymerMenuDivider>)
            compositeActions.push(...menuActions)
        }
        menuActions = compositeActions
    }
    
    const moreIcon = (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="white" d="M8.36719 16.3281C7.27865 16.3281 6.2526 16.1198 5.28906 15.7031C4.33073 15.2865 3.48438 14.7109 2.75 13.9766C2.01562 13.2422 1.4401 12.3958 1.02344 11.4375C0.606771 10.474 0.398438 9.44792 0.398438 8.35938C0.398438 7.27083 0.606771 6.2474 1.02344 5.28906C1.4401 4.32552 2.01302 3.47656 2.74219 2.74219C3.47656 2.00781 4.32292 1.43229 5.28125 1.01562C6.24479 0.598958 7.27083 0.390625 8.35938 0.390625C9.44792 0.390625 10.474 0.598958 11.4375 1.01562C12.401 1.43229 13.25 2.00781 13.9844 2.74219C14.7188 3.47656 15.2943 4.32552 15.7109 5.28906C16.1276 6.2474 16.3359 7.27083 16.3359 8.35938C16.3359 9.44792 16.1276 10.474 15.7109 11.4375C15.2943 12.3958 14.7188 13.2422 13.9844 13.9766C13.25 14.7109 12.401 15.2865 11.4375 15.7031C10.4792 16.1198 9.45573 16.3281 8.36719 16.3281ZM8.36719 15C9.28906 15 10.151 14.8281 10.9531 14.4844C11.7552 14.1406 12.4609 13.6667 13.0703 13.0625C13.6797 12.4531 14.1536 11.7474 14.4922 10.9453C14.8359 10.1432 15.0078 9.28125 15.0078 8.35938C15.0078 7.4375 14.8359 6.57552 14.4922 5.77344C14.1484 4.97135 13.6719 4.26562 13.0625 3.65625C12.4583 3.04688 11.7526 2.57292 10.9453 2.23438C10.1432 1.89062 9.28125 1.71875 8.35938 1.71875C7.4375 1.71875 6.57552 1.89062 5.77344 2.23438C4.97135 2.57292 4.26823 3.04688 3.66406 3.65625C3.0599 4.26562 2.58594 4.97135 2.24219 5.77344C1.90365 6.57552 1.73438 7.4375 1.73438 8.35938C1.73438 9.28125 1.90365 10.1432 2.24219 10.9453C2.58594 11.7474 3.0599 12.4531 3.66406 13.0625C4.27344 13.6667 4.97917 14.1406 5.78125 14.4844C6.58333 14.8281 7.44531 15 8.36719 15ZM4.71875 9.48438C4.40625 9.48438 4.13802 9.375 3.91406 9.15625C3.69531 8.93229 3.58594 8.66406 3.58594 8.35156C3.58594 8.03906 3.69531 7.77344 3.91406 7.55469C4.13802 7.33073 4.40625 7.21875 4.71875 7.21875C5.02604 7.21875 5.29167 7.33073 5.51562 7.55469C5.73958 7.77344 5.85156 8.03906 5.85156 8.35156C5.85156 8.66406 5.73958 8.93229 5.51562 9.15625C5.29688 9.375 5.03125 9.48438 4.71875 9.48438ZM8.35938 9.48438C8.05208 9.48438 7.78646 9.375 7.5625 9.15625C7.34375 8.93229 7.23438 8.66406 7.23438 8.35156C7.23438 8.03906 7.34375 7.77344 7.5625 7.55469C7.78646 7.33073 8.05208 7.21875 8.35938 7.21875C8.67188 7.21875 8.9375 7.33073 9.15625 7.55469C9.38021 7.77344 9.49219 8.03906 9.49219 8.35156C9.49219 8.66406 9.38021 8.93229 9.15625 9.15625C8.9375 9.375 8.67188 9.48438 8.35938 9.48438ZM12.0078 9.48438C11.6953 9.48438 11.4271 9.375 11.2031 9.15625C10.9844 8.93229 10.875 8.66406 10.875 8.35156C10.875 8.03906 10.9844 7.77344 11.2031 7.55469C11.4271 7.33073 11.6953 7.21875 12.0078 7.21875C12.3203 7.21875 12.5859 7.33073 12.8047 7.55469C13.0286 7.77344 13.1406 8.03906 13.1406 8.35156C13.1406 8.66406 13.0286 8.93229 12.8047 9.15625C12.5859 9.375 12.3203 9.48438 12.0078 9.48438Z"  />
        </svg>
    )

    let menu = isSelected && menuActions.length > 0 ? (
        <PolymerMenu action={moreIcon} align="right">
            {menuActions}
        </PolymerMenu>
    ) : null

    let paddingLevel = (20 * level)

    return (
        <div className={"sidebar-item noselect"}>
            <div className={contentClass} style={{ "paddingLeft": (paddingLeft + (paddingLevel)) + "px" }} onClick={selectRow}>
                {props.style == 'checked' ? checkmark : chevron}
                {iconElement}
                <div className="inner-content">
                    <span onClick={selectRow}>{props.title}</span>
                    <div style={iconContainerStyle}>
                        {menu}
                    </div> 
                </div>
            </div>

            {childContent}
        </div>
    )
}

export { Sidebar, SidebarTile, SidebarItem, SidebarAction, SidebarToolbarAction, SidebarSectionHeader, SidebarTitleHeader, SidebarSeparator, SidebarContent, SidebarSection, SidebarNavBack, SidebarToolbar, SidebarSectionContext, SidebarCategoryItem };
